import { Outlet } from "react-router-dom";
import "./App.css";
import { TopBar } from "./components/ui/TopBar";
import { Container, ThemeProvider, createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1F6099",
      contrastText: "#fff",
    },
  },
});

function App() {
  return (
    <div>
      <ThemeProvider theme={theme}>
        <TopBar />
        <Container>
          <Outlet />
        </Container>
      </ThemeProvider>
    </div>
  );
}

export default App;
